import React from 'react';
import { createRoot } from 'react-dom/client';
import { getPreferredLocation, mapCurrentUser } from './data/user.mjs';
import UserAccount from "../../../src/scripts/user-account/UserAccount.mjs";
import WindCreekClient from "../../../src/scripts/user-account/WindCreekClient.mjs";
import AccessBlocked from './components/AccessBlocked.mjs';
import CurrentPerks from "./components/CurrentPerks.mjs";
import PrimeTokensStore from './components/TokenStore.mjs';
import ApiError from "./components/ApiError.mjs";
import { query } from "../../../src/scripts/utils.mjs";
import { mapPerks } from "./data/primePerks.mjs";
import Loading from "./components/Loading.mjs";
import PrimePerksRules from "./components/PrimePerksRules.mjs";

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('token-store-app');

  if (container) {
    const root = createRoot(container);
    const primeTokensDiv = query("[data-select-prime-tokens]");

    root.render(
      <Loading />
    );

    UserAccount.windCreekClient = new WindCreekClient();

    if (UserAccount.isLoggedIn()) {
      const loginTypes = UserAccount.getLoginTypes();

      if (UserAccount.getLoginType() === loginTypes.EMAIL_PASSWORD) {
        Promise.all([
          UserAccount.getAccountData(),
          UserAccount.getProfile(),
        ])
          .then(([accountData, profileData]) => {
            const preferredLocation = getPreferredLocation(accountData.preferredLocation);

            Promise.all([
              UserAccount.getPrimePerksPrizes(preferredLocation),
              UserAccount.getRewards(),
              UserAccount.getPrimeTokens(preferredLocation),
              UserAccount.getRedeemedPrimePerks(preferredLocation),
            ]).then(([perks, rewards, primeTokens, redeemedPrimePerks]) => {
              primeTokensDiv.classList.remove("loading-animation");

              root.render(
                <>
                  { redeemedPrimePerks.length > 0 ? <CurrentPerks perks={redeemedPrimePerks} /> : null }
                  <PrimeTokensStore user={mapCurrentUser(accountData, profileData, rewards, primeTokens)} userAccount={UserAccount} preferredLocation={preferredLocation} perks={mapPerks(perks)} tier="brand" />
                  <PrimePerksRules />
                </>
              );
            }).catch((error) => {
              // showElement("[data-page-error-message]");
              // hideElement("[data-hide-on-page-error]");
              primeTokensDiv.classList.remove("loading-animation");

              console.log("Unable to load Rewards, Prime Tokens, or Prime Perks.");
              console.error(error);
              newrelic.noticeError(error);
              root.render(<ApiError />);
            });
          })
          .catch((error) => {
            // showElement("[data-page-error-message]");
            // hideElement("[data-hide-on-page-error]");
            primeTokensDiv.classList.remove("loading-animation");

            console.log("Unable to load account or profile data.");
            console.error(error);
            newrelic.noticeError(error);
            root.render(<ApiError />);
          }
        );
      } else {
        root.render(<AccessBlocked />);
      }
    } else {
      root.render(<AccessBlocked />);
    }
  }

});
